/// <reference path="../../libs/focus-trap.js" />
/// <reference path="../../framework/local-storage.js" />
/*
 * Makes the ajax request for recently viewed items to populate the recently viewed items page
 */
(function ($) {
    $(function () {
        const STORAGE_KEY = "RecentlyViewed",
            MAX_PRODUCTS_TO_SHOW_ON_PAGE = 40,
            selectors = {
                container: "#recent-products-data-container",
            },
            recentlyViewedProductPages = evo.storage.getItem(STORAGE_KEY) || [],
            $container = $(selectors.container),
            dataLoadUrl = $container.attr("data-load-url");

        // if there's no data load URL then we can't do anything
        if (typeof dataLoadUrl === "undefined") {
            return;
        }

        let productPagesToShow;

        recentlyViewedProductPages.length = Math.min(
            recentlyViewedProductPages.length,
            MAX_PRODUCTS_TO_SHOW_ON_PAGE,
        );
        productPagesToShow = recentlyViewedProductPages.slice(
            0,
            recentlyViewedProductPages.length,
        );

        if (productPagesToShow.length === 0) {
            return;
        }

        // Show loading spinner
        $container.addClass("loading");

        $.ajax({
            cache: false,
            method: "POST",
            data: JSON.stringify({ProductPageIds: productPagesToShow}),
            url: dataLoadUrl,
            contentType: "application/json"
        })
            .done(function (response) {
                // hide loading spinner
                $container.removeClass("loading");
                // show the container if there are recently viewed items
                if (response) {
                    $container.append(response);
                }
            })
            .fail(function () {
                // hide loading spinner
                $container.removeClass("loading");
                console.warn(
                    "There was an error loading the recently viewed component",
                );
            });

        // Bind the product thumb click events to push to the Google dataLayer.
        evo.$.body.on("click", ".js-product-thumb-details-link", function () {
            const productPageId = $(this).data("unique-id");

            window.dataLayerManager.pushProductClick(productPageId, "Recently Viewed - stand-alone page");
        });
    });
})(jQuery);
